import React, { useState } from 'react';
import { Button, FormGroup, Label, Input } from 'reactstrap';

interface MfaInputFormProps {
  onSubmit: (code: string) => void;
  onBack?: () => void | any;
  loading?: boolean;
  disabled?: boolean;
}

const MfaInputForm = ({ disabled, onSubmit, onBack, loading }: MfaInputFormProps) => {
  const [code, setCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.length === 6) {
      onSubmit(code);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 6) {
      setCode(value);
    }
  };

  return (
    <div>
      <h5 className="mb-4 text-center">Verify Code</h5>

      <div className="mb-4">
        <p className="text-muted text-center">Enter the 6-digit code from your authenticator app</p>
      </div>

      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="totpCode">Verification Code</Label>
          <Input
            type="text"
            id="totpCode"
            value={code}
            onChange={handleInputChange}
            placeholder="000000"
            maxLength={6}
            className="text-center"
            style={{ fontSize: '1.2rem', letterSpacing: '0.5em' }}
            disabled={loading || disabled}
          />
        </FormGroup>

        <div className="d-flex justify-content-between mt-4">
          {!!onBack && (
            <Button type="button" color="secondary" onClick={onBack} disabled={loading}>
              Back
            </Button>
          )}

          <Button type="submit" color="primary" disabled={code.length !== 6 || loading || disabled}>
            {loading ? 'Verifying...' : 'Verify'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default MfaInputForm;
